import { useDispatch } from 'react-redux';

export default function useStoreAddOn() {
    const dispatch = useDispatch();

    const executor = (car_addOn) => {
        return dispatch({
            type: 'SET_CAR_ADD_ON_LIST',
            payload: car_addOn,
        });
    };

    return executor;
};